<template>
    <div class="loader-overlay" v-if="visible">
        <div class="wave-loader">
            <div class="bar" v-for="n in 4" :key="n" :style="{animationDelay: (n * 0.1) + 's'}" />
        </div>
        <p class="loading-text">Loading...</p>
    </div>
</template>

<script>
    export default {
        props: {
            visible: {
                type: Boolean,
                default: true
            }
        },
    };
</script>

<style>
.loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(240, 240, 240, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    z-index: 999;
}

.wave-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
}

.bar {
    width: 8px;
    height: 20px;
    margin: 0 4px;
    background-color: #0046ff;
    border-radius: 4px;
    animation: wave 1s ease-in-out infinite;
}

.loading-text {
    font-size: 20px;
    font-weight: 600;
}

@keyframes wave {
    0%, 100% {
        height: 10px;
        opacity: 0;
    }
    50% {
        height: 50px;
        opacity: 1;
    }
}
</style>